import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';
import type { RentalLocation } from '@/api/reservations';

type Variables = {};
type Response = RentalLocation[];

export const useLocations = createQuery<Response, Variables, AxiosError>({
  queryKey: ['locations'],
  fetcher: () => {
    return client.get(`v2/rental_locations`).then((response) => {
      return response.data.data;
    });
  },
});
